import {Component, Suspense} from "react";
import Lottie from "lottie-react";
import Loading from "../../containers/loading/Loading";

export default class DisplayLottie extends Component {
  render() {
    const {animationData, style} = this.props;

    return (
      <Suspense fallback={<Loading />}>
        <Lottie animationData={animationData} loop={true} style={style} />
      </Suspense>
    );
  }
}
